import { InjectionToken } from '@angular/core';
import { BuildConfig } from '@common/util-models';

export const CONFIG = new InjectionToken<BuildConfig>('Application Config');
